import { z } from 'zod';
import { STAGES, zStage } from '../schemas/enums';
import posthogProjectsJson from './posthogProjects.json';

const zPosthogProject = z.strictObject({
  projectId: z.number().int().positive(),
  writeKey: z.string().regex(/^phc_[A-Za-z0-9]+$/, 'Invalid PostHog project write key'),
});

export const zPosthogProjects = z
  .record(zStage, zPosthogProject)
  .refine(
    (projects) => new Set(STAGES.map((stage) => projects[stage].projectId)).size === STAGES.length,
    'PostHog project IDs must be unique across stages',
  )
  .refine(
    (projects) => new Set(STAGES.map((stage) => projects[stage].writeKey)).size === STAGES.length,
    'PostHog project write keys must be unique across stages',
  );

export const posthogProjects = zPosthogProjects.parse(posthogProjectsJson);
